import DomSelector from '../utils/react-native-dom-parser';

export const round = (val) => {
  return Math.floor(val);
}

export const displayDate = (val, separator1 = "T", separator2 = "-") => {
  const sVal = val.split(separator1)[0].split(separator2);
  return `${sVal[2]}/${sVal[1]}/${sVal[0]}`;
}

export function deaccentWord(val) {
  return val.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

export const isFunction = (functionToCheck: any) => (
  functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
);

export const groupBy = (items: any[], key: any) => items.reduce(
  (result, item) => {
    const computedKey = isFunction(key) ? key(item) : item[key];
    return (
      {
        ...result,
        [computedKey]: [
          ...(result[computedKey] || []),
          item,
        ],
      }
    );
  },
  {},
);

export function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i >= 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

//HTML PARSING
export function htmlToObject(rawHtmlData: string) {
  if (rawHtmlData === undefined) {
    return [];
  }
  //@ts-ignore
  const rootNode = DomSelector(rawHtmlData);
  const p = rootNode.getElementsByTagName("p");

  let allText: { [key: string]: any }[] = [];
  let xob: { [key: string]: any } | undefined = undefined;

  p[0].children.map((xel: { tagName: string | undefined; text: string; attributes: { [x: string]: any; }; children: any[]; }) => {
    if (xel.tagName === undefined) {
      if (xob) {
        if (xob.text !== undefined) {
          allText.push(xob);
          xob = {};
          xob["text"] = xel.text;
          xob["select"] = {};
        }
      } else {
        xob = {};
        xob["text"] = xel.text;
        xob["select"] = {};
      }
    } else if (xel.tagName === "select" && xob !== undefined) {
      xob["type"] = xel.tagName;
      xob["select"]["id"] = xel.attributes["id"];
      xob["select"]["options"] = [];
      xob["select"]["options"] = xel.children.map((opt, i) => {
        const v = i === 0 ? '--' : opt.attributes["value"].replace(/'/gi, "")
        return {
          value: v,
          label: v.trim(),
        }
      });
    }
  });

  return allText;
}

